import React, { useContext } from "react";
import { Button, message } from "antd";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";
import { endExercise, ExerciseStatus, publishExercise } from "service/exercise";
import usePromiseCallback from "utils/usePromiseCallback";
import useVerifyExercise from "utils/useVerifyExercise";
import { errorMessage } from "service/service";
import useModalHandler from "utils/useModalHandler";
import ExerciseModal from "../ExerciseModal";

interface ListLinksProps {
    paperId: number;
    status: number;
    weekTimeId: number;
    exerciseId: number;
    onChange(): void;
}

export default function ListLinks({
    paperId,
    status,
    weekTimeId,
    exerciseId,
    onChange
}: ListLinksProps) {
    const history = useHistory();
    const { basename, course } = useContext(CourseContext);
    const { onVerify } = useVerifyExercise();

    const republishModal = useModalHandler();

    // onVerify 方法第二个参数
    const verifyStatusList = [
        {
            verifyStatus: ExerciseStatus.del,
            noticeContent: "练习活动已删除，请刷新页面"
        }
    ];

    const verifyDoneStatus = {
        verifyStatus: ExerciseStatus.done,
        noticeContent: "练习活动已结束，请刷新页面"
    };

    const verifyDoingStatus = {
        verifyStatus: ExerciseStatus.doing,
        noticeContent: "练习活动已开始，请刷新页面"
    };

    // 结束练习
    const onEndClick = usePromiseCallback(async function () {
        try {
            const executeContinue = await onVerify(exerciseId, [
                ...verifyStatusList,
                verifyDoneStatus
            ]);
            if (executeContinue) {
                await endExercise(paperId, course.weekTimeId);
                history.push(`${basename}/exercise/statics/${exerciseId}`);
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    // 去分析页
    async function gotoStatic() {
        try {
            const executeContinue = await onVerify(
                exerciseId,
                verifyStatusList
            );
            if (executeContinue)
                history.push(`${basename}/exercise/statics/${exerciseId}`);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    // 开始活动
    const startActivity = usePromiseCallback(async () => {
        try {
            await publishExercise(weekTimeId, exerciseId);
            history.push(`${basename}/exercise/detail/${exerciseId}`);
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    // 进入活动
    async function enterActivity() {
        try {
            const executeContinue = await onVerify(exerciseId, [
                ...verifyStatusList,
                verifyDoneStatus
            ]);
            if (executeContinue)
                history.push(`${basename}/exercise/detail/${exerciseId}`);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    // 编辑试题
    async function editExercises() {
        try {
            const executeContinue = await onVerify(exerciseId, [
                ...verifyStatusList,
                verifyDoingStatus,
                verifyDoneStatus
            ]);
            if (executeContinue)
                history.push(`${basename}/exercise/topics/${paperId}`);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    // 结束活动
    async function onEndActivityFn() {
        try {
            const executeContinue = await onVerify(
                exerciseId,
                verifyStatusList
            );
            if (executeContinue) onEndClick();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root}>
            {status === ExerciseStatus.NotStarted && (
                <Button type="link" onClick={startActivity}>
                    开始活动
                </Button>
            )}
            {status === ExerciseStatus.doing && (
                <Button type="link" onClick={enterActivity}>
                    进入活动
                </Button>
            )}
            {status === ExerciseStatus.doing && (
                <Button type="link" onClick={onEndActivityFn}>
                    结束活动
                </Button>
            )}
            {status === ExerciseStatus.done && (
                <Button type="link" onClick={republishModal.open}>
                    重新发布
                </Button>
            )}
            {status === ExerciseStatus.done && (
                <Button type="link" onClick={gotoStatic}>
                    练习分析
                </Button>
            )}
            {(status === ExerciseStatus.NoExercise ||
                status === ExerciseStatus.NotStarted) && (
                <Button type="link" onClick={editExercises}>
                    编辑试题
                </Button>
            )}

            {republishModal.render(
                <ExerciseModal
                    id={paperId}
                    type="republish"
                    visible={republishModal.visible}
                    onCancel={republishModal.close}
                    onOk={onChange}
                />
            )}
        </div>
    );
}
